import { BookOpen, Trash2, UserRoundPlus } from "lucide-react";
import React from "react";

const Actions = ({
  setAssignPrepGuideModalFlag,
  setCreateBatchFlag,
  setAssignMockInterviewModalFlag,
}) => {
  return (
    <div className="border-[1px] shadow border-[#E8E2D9] rounded-xl px-4 py-[1.2rem] transition-colors duration-200">
      <p className="text-[1rem] font-semibold text-[#101828]">Actions</p>

      <div className="mt-3 text-[.85rem]">
        <p className="text-[#667085] font-medium">Other actions</p>
        <div
          onClick={() => setCreateBatchFlag(true)}
          className="border-[1px] border-gray-300 hover:border-[#EDC043] hover:bg-[#FFFAEB]/60 hover:shadow-sm p-[.4rem] flex gap-2 rounded-lg items-center mt-2 cursor-pointer hover:scale-[1.03] transition-all ease-in-out duration-200 group"
        >
          <span className="bg-[#F2F4F7] group-hover:bg-[#FFFAEB] group-hover:border-[#FEDF89] border border-transparent p-1 rounded-md transition-colors duration-200">
            <UserRoundPlus size={16} className="text-[#475467] group-hover:text-[#DC6803] transition-colors duration-200" />
          </span>
          <span className="text-[#475467] group-hover:text-[#B54708] font-semibold transition-colors duration-200">
            Add Student
          </span>
        </div>
      </div>

      <div className="mt-5 text-[.85rem]">
        <p className="text-[#667085] font-medium">Assign</p>
        <div
          onClick={() => setAssignPrepGuideModalFlag(true)}
          className="border-[1px] border-gray-300 hover:border-[#EDC043] hover:bg-[#FFFAEB]/60 hover:shadow-sm p-[.4rem] flex gap-2 rounded-lg items-center mt-2 cursor-pointer hover:scale-[1.03] transition-all ease-in-out duration-200 group"
        >
          <span className="bg-[#F2F4F7] group-hover:bg-[#FFFAEB] group-hover:border-[#FEDF89] border border-transparent p-1 rounded-md transition-colors duration-200">
            <BookOpen size={16} className="text-[#475467] group-hover:text-[#DC6803] transition-colors duration-200" />
          </span>
          <span className="text-[#475467] group-hover:text-[#B54708] font-semibold transition-colors duration-200">
            Preparation Guide
          </span>
        </div>
        <div
          onClick={() => setAssignMockInterviewModalFlag(true)}
          className="border-[1px] border-gray-300 hover:border-[#EDC043] hover:bg-[#FFFAEB]/60 hover:shadow-sm p-[.4rem] flex gap-2 rounded-lg items-center mt-[.65rem] cursor-pointer hover:scale-[1.03] transition-all ease-in-out duration-200 group"
        >
          <span className="bg-[#F2F4F7] group-hover:bg-[#FFFAEB] group-hover:border-[#FEDF89] border border-transparent p-1 rounded-md transition-colors duration-200">
            <svg
              width="16"
              height="15"
              viewBox="0 0 14 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-[#475467] group-hover:text-[#DC6803] transition-colors duration-200"
            >
              <path
                d="M4.30313 11.5002H9.10313M6.70313 9.10019V11.5002M3.58313 9.10019H9.82313C10.8312 9.10019 11.3353 9.10019 11.7203 8.90401C12.059 8.73143 12.3344 8.45607 12.5069 8.11738C12.7031 7.73234 12.7031 7.22829 12.7031 6.22019V3.58019C12.7031 2.5721 12.7031 2.06805 12.5069 1.68301C12.3344 1.34432 12.059 1.06896 11.7203 0.896384C11.3353 0.700195 10.8312 0.700195 9.82313 0.700195H3.58313C2.57503 0.700195 2.07098 0.700195 1.68594 0.896384C1.34725 1.06896 1.07189 1.34432 0.899313 1.68301C0.703125 2.06805 0.703125 2.5721 0.703125 3.5802V6.22019C0.703125 7.22829 0.703125 7.73234 0.899313 8.11738C1.07189 8.45607 1.34725 8.73143 1.68594 8.90401C2.07098 9.10019 2.57503 9.10019 3.58313 9.10019Z"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.70312 8.16764C4.48172 7.34184 5.5388 6.83431 6.70313 6.83431C7.86745 6.83431 8.92453 7.34184 9.70313 8.16764M8.20313 4.00098C8.20313 4.8294 7.53155 5.50098 6.70313 5.50098C5.8747 5.50098 5.20313 4.8294 5.20313 4.00098C5.20313 3.17255 5.8747 2.50098 6.70313 2.50098C7.53155 2.50098 8.20313 3.17255 8.20313 4.00098Z"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="text-[#475467] group-hover:text-[#B54708] font-semibold transition-colors duration-200">
            Mock Interview
          </span>
        </div>
      </div>
    </div>
  );
};

export default Actions;
